var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-search", style: _vm.calcStyle }, [
    _c(
      "div",
      {
        ref: "searchOptions",
        staticClass: "options",
        style: _vm.isFirefox ? "max-height: 2.6em" : "",
      },
      _vm._l(_vm.options, function (option, i) {
        return _c(
          "div",
          {
            staticClass: "option",
            class: { active: _vm.selectedIndex === i },
            on: {
              click: function ($event) {
                return _vm.setSearchOption(i)
              },
            },
          },
          [
            _c("div", { staticClass: "option-item" }, [
              _vm._v(_vm._s(option.name)),
            ]),
          ]
        )
      }),
      0
    ),
    _c("div", { staticClass: "hor-line light-line" }),
    _vm.isShowContactsExtFilter
      ? _c("div", { staticClass: "filter-more" }, [
          _c(
            "div",
            {
              staticClass: "filter-btns-main",
              on: { click: _vm.openContactsFilter },
            },
            [
              _vm._m(0),
              _vm.contactsExtFilter && _vm.contactsExtFilter.length
                ? _c(
                    "div",
                    {
                      staticClass: "filter-subtitle",
                      on: { click: _vm.openContactsFilter },
                    },
                    [_vm._v(_vm._s(_vm.dataSearch(_vm.contactsExtFilter)))]
                  )
                : _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("search-comp.search-more"))),
                  ]),
            ]
          ),
          _c("div", { staticClass: "filter-btns-right" }, [
            _vm.contactsExtFilter && _vm.contactsExtFilter.length
              ? _c(
                  "div",
                  {
                    staticClass: "filter-close",
                    on: { click: _vm.closeInfoSearch },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-times",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm.isSearching ? _c("content-loader") : _vm._e(),
        _vm.isShowDefaultMine
          ? _c(_vm.searchType, {
              tag: "component",
              attrs: {
                id: "found-search-area",
                items: _vm.nonGlobalSearchItems,
                search: _vm.search,
                isFilter: !!_vm.search,
                isExtFilter: _vm.isExtFilter,
              },
            })
          : _vm._e(),
        !_vm.isShowDefaultMine && _vm.preparedItems.length
          ? _c("RecycleScroller", {
              ref: "global-search-scroller",
              staticClass: "scroller",
              style: _vm.scrollerStyle,
              attrs: {
                itemClass: "listItem",
                items: _vm.preparedItems,
                buffer: _vm.bufferSize,
                "key-field": "id",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ item, index }) {
                      return [
                        item.isTitle
                          ? _c("div", { staticClass: "section-title" }, [
                              _c("span", { staticClass: "title-text" }, [
                                _vm._v(_vm._s(item.text)),
                              ]),
                            ])
                          : !item.isLoadMore
                          ? _c("list-item", {
                              key: item.id,
                              class: { isTitle: item.isTitle },
                              attrs: { item: item, search: _vm.search },
                            })
                          : _c(
                              "div",
                              {
                                staticClass: "load-more",
                                on: {
                                  click: function ($event) {
                                    return _vm.searchMore(index, item)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "load-more-btn" }, [
                                  _vm._v(_vm._s(item.text)),
                                ]),
                              ]
                            ),
                        !item.isTitle && !item.isLoadMore
                          ? _c("div", { staticClass: "hor-line light-line" })
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                false,
                2603484577
              ),
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "filter-action" }, [
      _c("i", {
        staticClass: "fa fa-sliders",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }